export enum OrderingType {
  recommended = 1,
  cheapestShipment,
  fastestDelivery,
  bestRating,
  totalRatings,
  newFirst,
}
